<div>
  <mat-form-field floatLabel="always">
    <mat-label>{{'document.detail.label.document' | translate}}</mat-label>
    <input matInput [disabled]="true" [(ngModel)]="selectedFileName" />
    <input #choseFile [formControl]="form.controls['inputFile']" type="file" accept="{{acceptFileType}}" (change)="onSelectedFile($event)"
      style="display:none;" />
    <mat-icon class="browse-hover" matSuffix (click)="choseFile.click()">attachment</mat-icon>
  </mat-form-field>
</div>